// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bwSus3V","title":"Jc1RJPbg","intro":"_13njSry8","image":"_3qZVmqHB"};